export default {
  inventoryQuery: {
    search: {
      companyCode: '公司代码',
      companyName: '公司名称',
      departmentCode: '部门代码',
      departmentName: '部门名称',
      storageNo: '仓库编码',
      storageName: '仓库名称',
      productNo: '物料编码',
      productDesc: '物料名称',
      storageAmount: '库存金额',
      storageQuantity: '库存数量',
      gt: '大于',
      lt: '小于',
      notEqual: '不等于',
      equal: '等于',
    },
    columnList: {
      companyCode: '公司代码',
      companyName: '公司名称',
      departmentCode: '部门代码',
      departmentName: '部门名称',
      // batchNo:'入库批次号',
      storageNo: '仓库编码',
      storageName: '仓库名称',
      productNo: '物料编码',
      productDesc: '物料名称',
      storageCompanyCode: '库存公司编码',
      storageCompanyName: '库存公司名称',
      storageDepartmentCode: '库存部门编码',
      storageDepartmentName: '库存部门名称',
      batchNo: '业务批次号',
      accountPeriod: '期间(年月)',
      storageStatus: '状态(是否可用)',
      distributionBatchNo: '物流批次号',
      inboundQuantity: '入库数量',
      storagePrice: '库存单价',
      inboundAmount: '入库金额',
      storageQuantity: '库存数量',
      storageAmount: '库存金额',
      availableQuantity: '可用库存数量',
      occupationQuantity: '占用库存数量',
      lastBatchNo: '上一批次号',
      mainBusinesCost: '已发货成本',
      productUnit: '单位',
      currencyCode: '币种代码',
      currencyName: '币种名称',
      docType: '单据类型',
    },
    columDetail: {
      changeTime: '发生时间',
      postDate: '入账日期',
      changeNo: '更新批次',
      moveType: '移动类型',
      moveName: '移动类型名称',
      orderNo: '业务编号',
      storageQuantityAfter: '变更后库存数量',
      storageAmountAfter: '变更后库存金额',
      mainBusinessCostAfter: '变更后已发货成本',
      changeQuantity: '库存变动数量',
      changeAmount: '库存变动金额',
      storageQuantity: '当前库存数量',
      storageAmount: '当前库存金额',
    },
    placeholder: {
      companyCodePlaceholder: '请选择公司',
      departmentCodePlaceholder: '请选择部门',
      productDescPlaceholder: '请选择物品名称',
      storageNamePlaceholder: '请选择仓库名称',
      batchNoPlaceholder: '请输入入库批次号',
      docTypePlaceholder: '请选择单据类型',
    },
    msg: {
      errorTips: '请选择一条库存信息进行操作',
    },
  },
};
